import request from '../../../utils/request';

export interface ISnAiRule {
  id: number;
  rule_text: string;
  category: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string | null;
}

export interface ISnAiRuleListResponse {
  data: ISnAiRule[];
  count: number;
  page: number;
  limit: number;
}

const BASE = '/cmdb-sn-ai-rules';

class SnAiRulesService {
  async list(page: number, limit: number): Promise<ISnAiRuleListResponse> {
    const res = await request({ url: `${BASE}?page=${page}&limit=${limit}`, method: 'GET' });
    return res.data.body.data;
  }

  async create(rule_text: string, category: string): Promise<ISnAiRule> {
    const res = await request({ url: BASE, method: 'POST', data: { rule_text, category } });
    return res.data.body.data;
  }

  async update(id: number, rule_text: string, is_active: boolean, category: string): Promise<void> {
    await request({ url: `${BASE}/${id}`, method: 'PUT', data: { rule_text, is_active, category } });
  }

  async remove(id: number): Promise<void> {
    await request({ url: `${BASE}/${id}`, method: 'DELETE' });
  }
}

export default new SnAiRulesService();
